var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "329B7818-79C9-4AEC-9754-F3ACD0AB7060") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-Page---",
    transform: "translate(-21.000000, -724.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(-1.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-2",
    transform: "translate(0.000000, 624.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visible",
    transform: "translate(22.000000, 2.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0 C4.03445988,0 1.09422643,2.34219077 0,5.6060751 C1.09422643,8.86995944 4.03445988,11.2121212 7.5,11.2121212 C10.9655401,11.2121212 13.9057736,8.86993044 15,5.6060751 C13.9057736,2.34219077 10.9655401,0 7.5,0 Z M7.5,9.34344884 C5.42891558,9.34344884 3.75,7.67015718 3.75,5.6060751 C3.75,3.54196403 5.42891558,1.86870137 7.5,1.86870137 C9.57108442,1.86870137 11.25,3.54196403 11.25,5.6060751 C11.25,7.67012818 9.57108442,9.34344884 7.5,9.34344884 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83921838,4.3425998 C9.5788464,5.08222781 9.5788464,6.28140855 8.83921838,7.02103656 C8.09959037,7.76066458 6.90040963,7.76066458 6.16078162,7.02103656 C5.4211536,6.28140855 5.4211536,5.08222781 6.16078162,4.3425998 C6.90040963,3.60297178 8.09959037,3.60297178 8.83921838,4.3425998",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.2f9e616b9b9b268925d1f3aaec08dbba.svg";
export { ForwardRef as ReactComponent };